// extracted by mini-css-extract-plugin
module.exports = {"ViewJoinCode":"TeamDetailsView_ViewJoinCode__3se_i","DangerZone":"TeamDetailsView_DangerZone__3R-gw"};